enum ProgramType {
  Gfc = 'GFC',
  GfcEu = 'GfcEu',
  GfcJp = 'GfcJp',
  Go = 'Go',
  Ssd = 'Ssd',
  WholeFoods = 'WholeFoods',
}

export default ProgramType;
